import { render, staticRenderFns } from "./AdvisoryFlow.vue?vue&type=template&id=78ec36da&scoped=true"
import script from "./AdvisoryFlow.vue?vue&type=script&lang=js"
export * from "./AdvisoryFlow.vue?vue&type=script&lang=js"
import style0 from "./AdvisoryFlow.vue?vue&type=style&index=0&id=78ec36da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ec36da",
  null
  
)

export default component.exports